(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/validate/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/validate/page.js');
"use strict";

const {
  useState,
  memo
} = React;
const {
  Image
} = svs.content.image_v2;
const Button = svs.ui.ReactButton;
const {
  SpeechBubble
} = svs.ui.ReactSpeechBubble;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  OtpInput,
  PageWrapper,
  SpeechBubbleTurSlim,
  ScratchAnimation,
  actions
} = svs.ticketsValidate.components;
const {
  VALIDATED
} = svs.ticketsValidate.routes;
const getShortNameByTicketId = svs.ticketsValidate.utils.getShortNameByTicketId;
const ImageMemo = memo(_ref => {
  let {
    cssSelectors = '',
    image
  } = _ref;
  return React.createElement(Image, {
    cssSelectors: cssSelectors,
    image: image
  });
});
setGlobal('svs.ticketsValidate.pages.Validate', _ref2 => {
  let {
    history,
    match
  } = _ref2;
  const {
    dispatch
  } = svs.ticketsValidate.components.context.useValidateContext();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [completedCode, setCompletedCode] = useState('');
  const ticketInfo = svs.ticketsValidate.data.retailTicketInfo;
  const image = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.scratchImage) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.image);
  const type = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type;
  const onSubmit = async () => {
    const ticketId = match.params.ticketId;
    setLoading(true);
    svs.ui.loader.show();
    const {
      shortName
    } = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId);
    if (svs.core.userSession.isBlocked()) {
      svs.ticketsValidate.logger.info('User is blocked in NAR. Denying payment.');
      svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage();
      svs.ui.loader.hide();
      setLoading(false);
      return;
    }
    try {
      const result = await svs.ticketsValidate.utils.validateTicket({
        ticketId,
        code
      });
      dispatch({
        type: actions.SET_RESULT,
        payload: result
      });
      const shortName = getShortNameByTicketId(ticketId);
      svs.ticketgames.ticketUtility.utils.tracking.trackValidateOneTimePassword(shortName);
      const win = result.winAmount > 0;
      svs.ticketgames.ticketUtility.utils.tracking.trackValidatedTicketResult(shortName, win);
      svs.ticketsValidate.logger.info("ticket successfully validated. type: ".concat(shortName, ", win: ").concat(win));
      history.push(VALIDATED.replace(':ticketId', ticketId).replace(':code', code));
    } catch (error) {
      await svs.ticketsValidate.utils.showErrorDialog(error, function () {
        let {
          resultCode,
          errorCode
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        svs.ticketsValidate.utils.redirectByError({
          resultCode,
          errorCode
        }, svs.ticketsValidate.utils.getBrandByTicketId(ticketId), ticketId);
      });
      if (svs.ticketsValidate.utils.resultCodes[error === null || error === void 0 ? void 0 : error.resultCode]) {
        svs.ticketsValidate.logger.info("ticket validation failed. type: ".concat(shortName, ", reason: ").concat(error === null || error === void 0 ? void 0 : error.resultCode));
      } else {
        svs.ticketsValidate.logger.error("ticket validation failed. type: ".concat(shortName, ", reason: ").concat(JSON.stringify(error)));
      }
    }
    svs.ui.loader.hide();
    setLoading(false);
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center margin-bottom-2"
  }, React.createElement(GridCol, null, React.createElement("div", {
    style: {
      width: '300px',
      margin: '0px auto'
    }
  }, React.createElement("div", {
    className: "speech-bubble-wrapper"
  }, React.createElement(SpeechBubble, null, React.createElement(SpeechBubbleTurSlim, null, "Du f\xE5r det, vi lovar!"))), React.createElement("h1", {
    className: "h1"
  }, "Skrapa fram kod"), React.createElement("p", {
    className: "p"
  }, "Skriv in den ", React.createElement("b", null, "fyrsiffriga koden"), " som finns i kontrollrutan p\xE5 framsidan av lotten."), React.createElement("div", {
    className: "scratch-ticket"
  }, React.createElement("div", {
    className: "scratch-ticket-image-wrapper"
  }, image ? React.createElement(ImageMemo, {
    cssSelectors: "scratch-ticket-image ".concat(type),
    image: image
  }) : React.createElement("div", {
    className: "scratch-ticket-image"
  })), React.createElement(ScratchAnimation, {
    type: type
  })), React.createElement(OtpInput, {
    onChange: setCode,
    onComplete: setCompletedCode,
    onSubmit: onSubmit,
    value: code
  })))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center margin-bottom-3"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 6,
    sm: 12
  }, React.createElement(Button, {
    block: true,
    disabled: !completedCode || code !== completedCode || loading,
    focus: true,
    onClick: onSubmit,
    type: "button"
  }, "Kontrollera vinst"))));
});

 })(window);